import { Ref, ref } from "vue";

import { MyTaskService } from "@/service/MyTaskService";
import { DialogService } from "@/service/DialogService";
import { SweetAlertResult } from 'sweetalert2';
import { DakokuDataFull } from "@/types/Dakoku";
import { SoumuDakokuCheckRequest } from "@/types/MyTask";

export function useUpdate() {

  const isUpdating = ref(false);

  // 総務チェックを一括登録します。
  const updateSoumuChecks = (params: SoumuDakokuCheckRequest, form: Ref<DakokuDataFull[]>): void => {

    isUpdating.value = true;

    const srv = new MyTaskService();
    DialogService.nowloading('更新中...');

    srv.updateSoumuChecks(params).then((res: DakokuDataFull[] | null) => {
      if (res) {
        DialogService.info({
          text: `登録しました`
        }, true);

        // データを更新
        form.value = res;
      } else {
        DialogService.error({
          text: '予期せぬ事態が発生し登録に失敗しました'
        }, true);
      }
      isUpdating.value = false;
    });
  };

  // 承認チェックを一括登録します。
  const updateSyouninChecks = (params: number[], form: Ref<DakokuDataFull[]>): void => {

    isUpdating.value = true;

    const srv = new MyTaskService();
    DialogService.nowloading('更新中...');

    srv.updateSyouninChecks(params).then((res: DakokuDataFull[] | null) => {
      if (res) {
        DialogService.info({
          text: `登録しました`
        }, true);

        // データを更新
        form.value = res;
      } else {
        DialogService.error({
          text: '予期せぬ事態が発生し登録に失敗しました'
        }, true);
      }
      isUpdating.value = false;
    });
  };

  return {
    isUpdating,
    updateSoumuChecks,
    updateSyouninChecks,
  }
}
